var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-html"},[_c('ckeditor',{staticClass:"input-html-ckeditor",attrs:{"id":_vm.id,"editor":_vm.editor,"tag-name":"textarea"},on:{"input":_vm.emitInput},model:{value:(_vm.valueEdit),callback:function ($$v) {_vm.valueEdit=$$v},expression:"valueEdit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }